import React, { createContext, useCallback, useMemo, useRef, useState } from 'react'
import styled from 'styled-components'
import { Button, Drawer } from 'antd'
// import Lightbox from 'react-image-lightbox';
// import Lightbox, { ImagesListType } from 'react-spring-lightbox';
// import 'react-image-lightbox/style.css';
// import ArrowButton from './ArrowButton';
import ImageOverlay from './ImageOverlay';
import { IoIosClose } from "react-icons/io";
import useDelayShow from '../../hooks/useDelayShow';
// import { ImageProps } from '../../views/Home/components/Question';
import getLargestImage, { getLargestImg } from '../../hooks/useImage';
import 'photoswipe/dist/photoswipe.css'
import {PhotoSwipe} from 'react-photoswipe';
import { Gallery, Item } from 'react-photoswipe-gallery'
import { ImageProps } from '../../utils/util';

interface ImageContext {
  images?: ImageProps[];
  isOpen?: boolean,
  onPresent: (images: ImageProps[],index: number) => void,
  onDismiss: () => void
}

export const Context = createContext<ImageContext>({
  onPresent: (images:ImageProps[],index: number) => null,
  onDismiss: () => {},
})

const Images: React.FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [images, setImages] = useState<ImageProps[]>([])
  const [photoIndex,setIndex] = useState(0)
  const handlePresent = useCallback((images:ImageProps[],index:number) => {
    setImages(images)
    setIndex(index)
    setIsOpen(true)
    
  },[])

  const handleDismiss = useCallback(() => { 
    setIsOpen(false)
    setImages([])
  },[])
  const photoSwipeRef = useRef(null)
  const items = useMemo(()=>images.map(i=>({src: getLargestImg(i).url,w: getLargestImg(i).width,h: getLargestImg(i).height,title:''})),[images])
  console.log(new Date().getTime(),'photoIndex',photoIndex,images.length)
  return (
    <Context.Provider value={{
      images,
      isOpen,
      onPresent: handlePresent,
      onDismiss: handleDismiss,
    }}>
      {children}
      {  
      images.length > 0 && isOpen && 
      // @ts-ignore
      <PhotoSwipe ref={photoSwipeRef} isOpen={isOpen} items={items}
        options={{index:photoIndex,maxSpreadZoom:1}}
        onClose={()=>{
          handleDismiss() 
        }} 
      />
      }
    </Context.Provider>
  )
}

const StyledModalWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
`

const StyledModalBackdrop = styled.div`
  background-color: #00000088;
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
`

export default Images